import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// Expected data shape:
// [
//   { date: '2025-01-01', counts: { PROMO10: 3, PROMO20: 5 } },
//   { date: '2025-01-02', counts: { PROMO10: 2, PROMO30: 1 } },
// ]

const generateColor = (seed) => {
    // simple deterministic color from string
    let hash = 0;
    for (let i = 0; i < seed.length; i++) hash = seed.charCodeAt(i) + ((hash << 5) - hash);
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 70%, 55%)`;
};

const PromoCodeUsageChart = ({ data }) => {
    const { labels, datasets } = useMemo(() => {
        const labelsLocal = (data || []).map((d) => d.date);
        const promoCodesSet = new Set();
        (data || []).forEach((d) => {
            const codes = Object.keys(d?.counts || {});
            codes.forEach((c) => promoCodesSet.add(c));
        });
        const promoCodes = Array.from(promoCodesSet);

        const datasetsLocal = promoCodes.map((code) => {
            const backgroundColor = generateColor(code);
            const borderColor = backgroundColor;
            return {
                label: code,
                data: (data || []).map((d) => (d?.counts?.[code] ?? 0)),
                backgroundColor,
                borderColor,
                borderWidth: 1,
            };
        });

        return { labels: labelsLocal, datasets: datasetsLocal };
    }, [data]);

    const chartData = { labels, datasets };
    const options = {
        responsive: true,
        plugins: {
            legend: { position: 'top' },
            title: { display: true, text: 'Promo code usages by date' },
        },
        scales: {
            x: { stacked: false },
            y: { beginAtZero: true, ticks: { precision: 0 } },
        },
    };

    return (
        <div style={{ width: '100%', height: '100%' }}>
            <Bar data={chartData} options={options} />
        </div>
    );
};

export { PromoCodeUsageChart, generateColor };

